import React from "react";
import { ArrowRight } from "lucide-react";
import { openAgent } from "../../utils/openAgent";

export default function PhysicalAiCtaSection() {

  return (
    <section className="relative w-full overflow-hidden bg-[#020712]">
      {/* Background Image Container */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/physical-ai/physical-ai-cta-bg.png"
          alt="Physical AI autonomous mobile robot in warehouse"
          className="w-full h-full object-cover object-right md:object-center"
        />
        {/* Subtle dark gradient overlay on left for enhanced text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#020712]/90 via-[#020712]/50 to-transparent md:via-[#020712]/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-[1380px] px-6 sm:px-8 lg:px-12 py-20 sm:py-24 lg:py-28 min-h-[480px] sm:min-h-[540px] flex items-center">
        <div className="flex flex-col items-start max-w-[560px]">
          {/* Eyebrow */}
          <p className="text-[12px] sm:text-[13px] font-bold uppercase tracking-[2.5px] text-[#94A3B8]">
            LET'S BUILD TOGETHER
          </p>

          {/* Heading */}
          <h2 className="mt-3 text-[34px] sm:text-[42px] lg:text-[48px] font-bold leading-[1.15] tracking-tight text-white">
            Ready to put Physical AI <br className="hidden sm:inline" />
            to work?
          </h2>

          {/* Description */}
          <p className="mt-4 text-[14px] sm:text-[15.5px] leading-[24px] sm:leading-[26px] text-[#CBD5E1]">
            From autonomous material movement to intelligent inspection, cleaning, delivery and service robotics.
          </p>

          {/* CTA Button */}
          <div className="mt-8">
            <button
              onClick={openAgent}
              className="group inline-flex items-center gap-3 rounded-full bg-white px-7 sm:px-8 py-3.5 sm:py-4 text-[14.5px] sm:text-[15px] font-semibold text-[#0F172A] shadow-[0_0_30px_rgba(255,255,255,0.4)] transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_0_45px_rgba(255,255,255,0.65)] active:scale-95 cursor-pointer"
            >
              <span>Talk to Our Team</span>
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
